export default __webpack_public_path__ + "static/media/Sneha.c11d7d7f.jpg";